export default __webpack_public_path__ + "static/media/afterEffects.a92bd219.png";